import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export function WithdrawChildConsentModal({ open, onOpenChange, child, loading, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="withdraw-child-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Withdraw consent for {child?.name}?
          </DialogTitle>
          <DialogDescription className="pt-2 text-left space-y-3">
            <span className="block">
              {child?.name}'s learning access (web &amp; WhatsApp) will be <strong>disabled immediately</strong>.
              Your other children are <strong>not</strong> affected.
            </span>
            <span className="block bg-amber-50 border border-amber-200 rounded-md p-3 text-amber-800 text-sm">
              We keep their data for a <strong>30-day grace period</strong>. Re-grant consent within that time to
              restore everything. If you don't, all of {child?.name}'s personal data will be
              <strong> permanently erased</strong> as required by the DPDP Act, 2023. We'll email you reminders.
            </span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading} data-testid="withdraw-child-cancel">
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading} data-testid="withdraw-child-confirm">
            {loading ? "Processing..." : "Yes, withdraw consent"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
